import { BoardElement } from '../types';

export function findLongestSubarray(arr: Array<BoardElement>, itemToFind: BoardElement) {
    let resultArr: Array<BoardElement> = [itemToFind];

    const middleIndex = (arr.length - 1) / 2;

    for (let i = middleIndex + 1; i < arr.length; i++) {
        const element = arr[i];
        if (element.value === itemToFind.value) {
            resultArr.push(element);
        } else {
            break;
        }
    }
    for (let i = middleIndex - 1; i >= 0; i--) {
        const element = arr[i];
        if (element.value === itemToFind.value) {
            resultArr.unshift(element);
        } else {
            break;
        }
    }

    // Return max length
    return resultArr;
}